<template>
  <v-container class="ma-0 pa-0 mw-100">
    <v-card class="px-5 px-md-13 px-sm-7 px-lg-16 py-5 py-md-8 py-sm-5 py-lg-10" @keydown.enter="sign">
      <v-row>
        <v-col cols="12">
          <header-medium :text="$t('Authenticate.Title')" />
        </v-col>
      </v-row>
      <v-row>
        <v-card-text >
          <v-container class="ma-0 pa-0 mw-100">
            <p v-text="$t('Authenticate.KeySendMessage_1')" class="text-center mb-0"></p>
            <p v-text="$t('Authenticate.KeySendMessage_2')" class="text-center mb-0"></p>
            <p v-text="$t('Authenticate.KeySendMessage_3')" class="text-center"></p>
          </v-container>
          <v-row justify="center" >
            <v-col cols="12" sm="5" md="5">
              <v-otp-input v-model="otp" @finish="focusSubmit" :label="$t('Authenticate.EnterCode')" type="number"></v-otp-input>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="12" sm="5" md="5">
              <p class="text-center ma-0 pa-0 caption">
                {{ $t("Authenticate.reference") }}{{ reference }}
              </p>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="12" sm="5" md="5">
              <p class="text-center ma-0 pa-0 caption">
                <v-btn color="primary" @click="retrySMS" plain :disabled="disableRetry">
                  <span style="white-space: normal;">{{ $t("Authenticate.NotReceivedCodeLink") }}
                  </span>
                </v-btn>
              </p>
            </v-col>
          </v-row>
        </v-card-text>
      </v-row>
      <v-row v-if="smsSend" justify="center">
        <v-col cols="12" sm="12" align="center">
          <base-timer ref="timer" :time="time"></base-timer>
        </v-col>
      </v-row>
      <v-row class="pt-5" dense v-if="!mobile">
        <v-col cols="12" sm="4" class="text-left">
          <custom-button :text="$t('Navigation.cancel_workflow')" color="red" @click="cancel()"></custom-button>
        </v-col>
        <v-col cols="12" sm="8" class="text-right">
          <custom-button :text="$t('DetailsPage.labels.previous')" @click="nextPage(2)"></custom-button>
          <custom-button id="sign" :disabled="disabled" :text="buttonText" @click="sign"></custom-button>
        </v-col>
      </v-row>
      <v-container class="ma-0 pa-0 mw-100" v-if="mobile">
        <v-row>
          <v-col cols="12" sm="8" class="text-center">
            <custom-button :text="$t('Navigation.cancel_workflow')" color="red" @click="cancel()"></custom-button>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="8" class="text-center">
            <custom-button :text="$t('DetailsPage.labels.previous')" @click="nextPage(2)"></custom-button>
            <custom-button :disabled="disabled" :text="buttonText" @click="sign"></custom-button>
          </v-col>
        </v-row>
      </v-container>
      <custom-overlay>
      </custom-overlay>

    </v-card>
  </v-container>
</template>

<script>
import i18n from "@/i18n";
import HeaderMedium from "../../components/ui/text/HeaderMedium.vue";
import CustomButton from "../../components/ui/input/CustomButton.vue";
import { log } from "@/helpers/logger";
import BaseTimer from "../../components/ui/other/BaseTimer.vue";
import CustomOverlay from "../../components/ui/other/Overlay.vue";

export default {
  name: "aes-authenticate",
  title: i18n.t("Authenticate.Title"),
  components: {
    HeaderMedium,
    CustomButton,
    BaseTimer,
    CustomOverlay,
  },
  data() {
    return {
      buttonText: '',
      workflow: null,
      otp: "",
      time: 0,
      disableRetry: true,
      smsSend: false,

    };
  },
   
  created: async function () {
    this.$emit("step", 3);
    this.workflow = this.currentWorkflow;

    this.buttonText = this.workflow.signer_type.split("_")[1] === 'signature' ? i18n.t('Navigation.sign_now') : i18n.t('Navigation.seal_now')

    var app = this;


    await this.$store
      .dispatch("data/getSMS", this.workflow)
      .then(() => {
        this.smsSend = true;
      })
      .catch((err) => {
        log("AesAuthenticate.created() - " + err, 'error');
        return;
      }).finally(() => {
        setTimeout(function () {
          app.disableRetry = false;
        }, 60000);
      });
    this.mainColor = this.$vuetify.theme.themes.light.primary;
  },
  computed: {
    mobile() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    disabled() {
      return (this.$store.state.loading || this.otp.length != 6) ? true : false;
    },
    currentWorkflow() {
      return this.$store.state.auth.workflow;
    },
    currentFiles() {
      return this.$store.state.data.files;
    },
    reference() {
      return this.$store.state.data.reference;
    },
  },
  methods: {
    focusSubmit() {
     document.getElementById("sign").focus();
    }, 
    cancel() {
      this.$emit("refuse", true);
    },
    retrySMS() {
      this.time = 0;

      this.disableRetry = true;

      var signer = {
        workflow_id: this.workflow.workflow_id,
        signer_id: this.workflow.signer_id,
        first_name: this.workflow.first_name,
        last_name: this.workflow.last_name,
        phone: this.workflow.phone,
        email: this.workflow.email,
      };

      var app = this;

      this.$store.dispatch("data/retrySMS", signer).finally(() => {
        this.time = 300;
        setTimeout(function () {
          app.disableRetry = false;
        }, 60000);
      });
    },
    nextPage(val) {
      this.$store.state.auth.workflow = this.workflow;
      this.$router.push(
        "/workflow/" +
        this.currentWorkflow.workflow_id +
        "/" +
        this.currentWorkflow.signer_id +
        "/authenticate"
      );
      this.$store.commit("set_loading", true);
    },
    async sign() {
      this.$store
        .dispatch("data/checkSMS", {
          workflow: this.currentWorkflow,
          auth_token: this.$store.state.data.auth_token,
          otp: this.otp,
        })
        .then(() => {
          this.$store
            .dispatch("data/signNow", {
              workflow: this.currentWorkflow,
              files: this.currentFiles,
              auth_token: this.$store.state.data.auth_token,
              otp: this.otp,
              ip: this.currentWorkflow.ip,
            })
            .then(() => {

              log(
                "MainPage.Authenticate.sign() - sign now workflow " +
                this.currentWorkflow.workflow_id +
                " by signer " +
                this.currentWorkflow.signer_id,
                "info"
              );
              this.$router.push("/summary/finished");
            })
            .catch((err) => {
              this.otp = "";
              log("MainPage.sign() - " + err, "error");
            })
        })
        .catch((err) => {
          this.otp = "";
          log("MainPage.Authenticate.sign() - " + err, "error");
        })


    },
  },
};
</script>
